import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCode = function SvgCode(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16.344 11.922l2.297-2.297a1.02 1.02 0 000-1.406 1.02 1.02 0 00-1.407 0l-2.297 2.297-2.296-2.297a1.02 1.02 0 00-1.407 0 1.02 1.02 0 000 1.406l2.297 2.297-2.297 2.297a1.02 1.02 0 000 1.406c.188.188.47.281.704.281.234 0 .515-.094.703-.281l2.296-2.297 2.297 2.297c.188.188.47.281.703.281.235 0 .516-.094.704-.281a1.02 1.02 0 000-1.406l-2.297-2.297zM7.688 8.266a1.02 1.02 0 00-1.407 0l-2.297 2.296-2.296-2.296a1.02 1.02 0 00-1.407 0 1.02 1.02 0 000 1.406l2.297 2.297-2.297 2.25a1.02 1.02 0 000 1.406c.188.188.469.281.703.281.235 0 .516-.094.704-.281l2.296-2.297 2.297 2.297c.188.188.469.281.703.281.235 0 .516-.094.704-.281a1.02 1.02 0 000-1.406L5.39 11.922l2.296-2.297a.962.962 0 000-1.36zM22.906 22.938a.99.99 0 00.985-.985V1.984A.99.99 0 0022.906 1a.99.99 0 00-.984.984v19.97a.99.99 0 00.984.983z"
  }));
};

export default SvgCode;